import React, { useState, useEffect, useRef } from 'react';
import Styles from '../css/DialogBoxVacantSubstitution.module.css';
import Axios from '../../../components/Axios/Axios';

export default function DialogBoxVacantSubstitution(props) {
    const { data, onClose, onSaved } = props;
    const isNew = !data;

    const [vacantTerrId, setVacantTerrId]       = useState(data ? data.VACANT_TERR_ID   : '');
    const [vacantTerrName, setVacantTerrName]   = useState(data ? data.VACANT_TERR_NAME : '');
    const [subEmail, setSubEmail]               = useState(data ? data.SUB_EMAIL         : '');
    const [subTerrId, setSubTerrId]             = useState(data ? data.SUB_TERR_ID       : '');
    const [selectedRepName, setSelectedRepName] = useState(
        data ? `${data.FIRST_NAME || ''} ${data.LAST_NAME || ''} — ${data.SUB_TERR_ID || ''}`.trim() : ''
    );
    const [teamId, setTeamId]                   = useState('');
    const [teamOptions, setTeamOptions]         = useState([]);
    const [nameSearch, setNameSearch]           = useState('');
    const [searchResults, setSearchResults]     = useState([]);
    const [vacantOptions, setVacantOptions]     = useState([]);
    const [vacantSearch, setVacantSearch]       = useState('');
    const [errorMessage, setErrorMessage]       = useState('');
    const [wiggle, setWiggle]                   = useState(false);
    const [vacantFocused, setVacantFocused]     = useState(false);
    const debounceRef = useRef(null);
    const vacantBlurRef = useRef(null);

    useEffect(() => {
        Axios('/api/v1/admin/get-user-teams', {}, (results) => {
            if (results) setTeamOptions(results);
        });
        if (isNew) {
            Axios('/api/v1/admin/get-vacant-territories', {}, (results) => {
                if (results) setVacantOptions(results);
            });
        }
    }, []);

    const runSearch = (name, team) => {
        if (!name.trim()) { setSearchResults([]); return; }
        Axios('/api/v1/admin/search', { NAME: name.trim(), TEAM_ID: team }, (results) => {
            setSearchResults(results || []);
        });
    };

    const handleNameSearch = (value) => {
        setNameSearch(value);
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => runSearch(value, teamId), 300);
    };

    const handleTeamChange = (value) => {
        setTeamId(value);
        clearTimeout(debounceRef.current);
        if (nameSearch.trim()) {
            debounceRef.current = setTimeout(() => runSearch(nameSearch, value), 100);
        }
    };

    const handleRepSelect = (user) => {
        setSubEmail(user.WORK_EMAIL);
        setSubTerrId(user.TERR_ID || '');
        setSelectedRepName(`${user.FIRST_NAME} ${user.LAST_NAME} — ${user.TERR_ID}`);
        setSearchResults([]);
        setNameSearch('');
    };

    const clearRepSelection = () => {
        setSubEmail('');
        setSubTerrId('');
        setSelectedRepName('');
    };

    const handleVacantSelect = (v) => {
        setVacantTerrId(v.TERR_ID);
        setVacantTerrName(v.TERR_NAME || '');
        setVacantSearch('');
    };

    const clearVacantSelection = () => {
        setVacantTerrId('');
        setVacantTerrName('');
    };

    const filteredVacant = vacantFocused && !vacantTerrId
        ? (vacantSearch.trim()
            ? vacantOptions.filter(v =>
                v.TERR_ID.includes(vacantSearch) ||
                (v.TERR_NAME || '').toLowerCase().includes(vacantSearch.toLowerCase())
              )
            : vacantOptions)
        : [];

    const save = () => {
        if (!vacantTerrId.trim() || !subEmail.trim() || !subTerrId.trim()) {
            setErrorMessage('All fields are required.');
            setWiggle(true);
            setTimeout(() => setWiggle(false), 500);
            return;
        }
        Axios('/api/v1/admin/upsert-vacant-substitution', {
            VACANT_TERR_ID:   vacantTerrId.trim(),
            VACANT_TERR_NAME: vacantTerrName,
            SUB_EMAIL:        subEmail.trim(),
            SUB_TERR_ID:      subTerrId.trim()
        }, () => {
            onSaved();
            onClose();
        });
    };

    return (
        <div className={Styles.editScreen}>
            <div className={Styles.title}>
                <div></div>
                <div className={Styles.TitleText}>{isNew ? 'Add Substitution' : 'Edit Substitution'}</div>
                <div className={Styles.close} onClick={onClose}><i className='fas fa-times'></i></div>
            </div>
            <div className={Styles.body}>
                {errorMessage && <div className={Styles.errorMessage}>{errorMessage}</div>}

                {isNew ? (
                    <div className={Styles.repSearchSection}>
                        <div className={Styles.inputTitle}>VACANT TERRITORY <span className={Styles.required}>*</span></div>
                        <input
                            type='text'
                            className={Styles.nameSearchInput}
                            value={vacantSearch}
                            onChange={(e) => setVacantSearch(e.target.value)}
                            placeholder='Search by territory ID or name...'
                            onFocus={() => {
                                clearTimeout(vacantBlurRef.current);
                                setVacantFocused(true);
                            }}
                            onBlur={() => {
                                vacantBlurRef.current = setTimeout(() => setVacantFocused(false), 150);
                            }}
                        />
                        {vacantTerrId && (
                            <div className={Styles.selectedRep}>
                                <i className='fas fa-map-marker-alt'></i> {vacantTerrId} — {vacantTerrName}
                                <span className={Styles.clearRep} onClick={clearVacantSelection}>×</span>
                            </div>
                        )}
                        {filteredVacant.length > 0 && (
                            <div className={Styles.searchResultsList}>
                                {filteredVacant.slice(0, 10).map((v, i) => (
                                    <div key={i} className={Styles.searchResultItem} onClick={() => handleVacantSelect(v)}>
                                        {v.TERR_ID} — {v.TERR_NAME}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ) : (
                    <div className={Styles.infoBlock}>
                        <div className={Styles.infoRow}>
                            <span className={Styles.label}>VACANT TERRITORY</span>
                            <span className={Styles.value}>{data.VACANT_TERR_ID} — {data.VACANT_TERR_NAME}</span>
                        </div>
                        <div className={Styles.infoRow}>
                            <span className={Styles.label}>DIST MGR</span>
                            <span className={Styles.value}>{data.VACANT_DIST_MGR_NAME || '—'}</span>
                        </div>
                    </div>
                )}

                <div className={Styles.repSearchSection}>
                    <div className={Styles.inputTitle}>SUBSTITUTE REP <span className={Styles.required}>*</span></div>
                    <div className={Styles.repSearchRow}>
                        <select
                            className={Styles.teamSelect}
                            value={teamId}
                            onChange={(e) => handleTeamChange(e.target.value)}
                        >
                            <option value=''>All Teams</option>
                            {teamOptions.map((t, i) => (
                                <option key={i} value={t.TEAM_ID}>{t.TEAM_ID}</option>
                            ))}
                        </select>
                        <input
                            type='text'
                            className={Styles.nameSearchInput}
                            value={nameSearch}
                            onChange={(e) => handleNameSearch(e.target.value)}
                            placeholder='Search by name...'
                        />
                    </div>
                    {selectedRepName && (
                        <div className={Styles.selectedRep}>
                            <i className='fas fa-user-check'></i> {selectedRepName}
                            <span className={Styles.clearRep} onClick={clearRepSelection}>×</span>
                        </div>
                    )}
                    {searchResults.length > 0 && (
                        <div className={Styles.searchResultsList}>
                            {searchResults.slice(0, 10).map((u, i) => (
                                <div key={i} className={Styles.searchResultItem} onClick={() => handleRepSelect(u)}>
                                    {u.FIRST_NAME} {u.LAST_NAME} — {u.TERR_ID}
                                    <span className={Styles.teamBadge}>T{u.TEAM_ID}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className={Styles.fieldRow}>
                    <div className={Styles.set}>
                        <div className={Styles.inputTitle}>SUB TERRITORY ID <span className={Styles.required}>*</span></div>
                        <input
                            type='text'
                            className={Styles.DefaultInputForm}
                            value={subTerrId}
                            onChange={(e) => setSubTerrId(e.target.value)}
                            placeholder='e.g. 13409104'
                        />
                        <div className={Styles.hint}>Auto-filled from rep selection. Override if needed.</div>
                    </div>
                </div>

                <div className={[Styles.buttonRow, wiggle ? Styles.Wiggle : ''].join(' ')}>
                    <div id={Styles.cancel} onClick={onClose}>CANCEL</div>
                    <div id={Styles.submit} onClick={save}>SAVE</div>
                </div>
            </div>
        </div>
    );
}
